<div class="ov">
  <!-- Nézet: számlák (OSA) vagy a Kassza napi nyugta-összesítői -->
  <div class="n-szuro-sor" style="margin-bottom:6px">
    <div class="ov-irany" role="radiogroup" aria-label="Nézet">
      <button type="button" [class.aktiv]="nezet === 'szamla'" (click)="nezet = 'szamla'"><ion-icon name="document-text-outline"></ion-icon>Számlák</button>
      <button type="button" [class.aktiv]="nezet === 'nyugta'" (click)="nezetNyugta()"><ion-icon name="receipt-outline"></ion-icon>Nyugta-összesítők</button>
    </div>
    <span class="spacer"></span>
  </div>

  <ng-container *ngIf="nezet === 'szamla'">
  <!-- Irány + gyorskereső + NAV-állapot -->
  <div class="n-szuro-sor ov-fej">
    <div class="ov-irany" role="radiogroup" aria-label="Irány">
      <button type="button" [class.aktiv]="irany === 'inbound'" (click)="iranyValt('inbound')"><ion-icon name="arrow-down"></ion-icon>Bejövő (beszerzés)</button>
      <button type="button" [class.aktiv]="irany === 'outbound'" (click)="iranyValt('outbound')"><ion-icon name="arrow-up"></ion-icon>Kimenő (értékesítés)</button>
    </div>
    <input type="search" [(ngModel)]="keresoSzoveg" placeholder="Számlaszám, partner, adószám…" class="ov-kereso">
    <label><input type="checkbox" [(ngModel)]="csakKonyveletlen"> csak a még nem könyveltek</label>
    <!-- A TÁBLÁZAT szűrése keltezés szerint (a NAV-lekérés időszaka lent, külön állítható). -->
    <span class="ov-datumszuro" title="A listában látható számlák szűrése a számla kelte szerint">
      Kelt <input type="date" [(ngModel)]="szuroTol" aria-label="Kelte -tól"> – <input type="date" [(ngModel)]="szuroIg" aria-label="Kelte -ig">
      <button type="button" class="ov-torol" *ngIf="szuroTol || szuroIg" (click)="szuroTol = ''; szuroIg = ''" title="Dátumszűrés törlése">×</button>
    </span>
    <span class="spacer"></span>
    <button type="button" class="ov-gomb" (click)="navLekeres(false)" [disabled]="!!feladatId" title="A könyvelési év számláinak lekérése a NAV Online Számla rendszeréből">
      <ion-icon name="cloud-download-outline"></ion-icon>Frissítés a NAV-tól
    </button>
    <!-- Számlaképek: a bepipált forrásból (számlázóprogram, ha van; különben NAV Számlázó), háttérben. -->
    <button type="button" class="ov-gomb" *ngIf="irany === 'outbound'" [disabled]="!!kepFeladat || !!feladatId || !szamlak.length"
            (click)="kepekLetolt()" title="A kimenő számlák hiányzó képeinek letöltése a bepipált forrásból (Számlázz.hu / Billingo, vagy ha nincs ilyen, a NAV Számlázóból)">
      <ion-icon [name]="kepFeladat ? 'hourglass-outline' : 'images-outline'"></ion-icon>{{ kepFeladat ? 'Számlaképek…' : 'Számlaképek' }}
    </button>
    <button type="button" class="ov-gomb halvany-gomb" (click)="reszletesNyit = !reszletesNyit" [class.aktiv]="reszletesNyit">
      <ion-icon name="options-outline"></ion-icon>Időszak, előnézet
    </button>
  </div>

  <div class="ov-allapot" *ngIf="feladatId || navUzenet">
    <ion-spinner *ngIf="feladatId" name="dots"></ion-spinner>
    <ion-icon *ngIf="!feladatId" name="information-circle-outline"></ion-icon>
    <span>{{ feladatId ? (halad?.uzenet || navUzenet) : navUzenet }}</span>
    <span *ngIf="feladatId" class="halvany"> · a tárolt számlákkal közben is dolgozhatsz</span>
  </div>

  <!-- Régebbi időszak / előnézet: csak a kijelöltek kerülnek be -->
  <div class="n-szukites" *ngIf="reszletesNyit">
    <label>Dátumtól <input type="date" [(ngModel)]="idoszak.tol"></label>
    <label>Dátumig <input type="date" [(ngModel)]="idoszak.ig"></label>
    <label class="ov-sor"><input type="checkbox" [(ngModel)]="elonezet"> Előnézet – csak a kijelölteket emeli be</label>
    <button type="button" class="ov-gomb" (click)="navLekeres()" [disabled]="!!feladatId"><ion-icon name="search-outline"></ion-icon>Lekérdezés</button>
  </div>

  <!-- Tömeges műveletek -->
  <div class="ov-tomeg" *ngIf="szamlak.length">
    <button type="button" class="ov-link" (click)="kijelolMind()">Kijelölés: mind / egyik sem</button>
    <button *ngIf="elonezet" type="button" class="ov-gomb" [disabled]="!kijelolt.size || beemelFut" (click)="beemel()">
      <ion-icon name="download-outline"></ion-icon>Kijelöltek beemelése ({{ kijelolt.size }})
    </button>
    <button *ngIf="!elonezet && tomeges" type="button" class="ov-gomb fo" [disabled]="!kijelolt.size" (click)="csoportos()">
      <ion-icon name="layers-outline"></ion-icon>Csoportos könyvelés ({{ kijelolt.size }})
    </button>
    <button type="button" class="ov-link" (click)="partnerekKinyer()">Partnerek felvétele a listából</button>
    <span class="spacer"></span>
    <span class="halvany">{{ lathato.length }} / {{ szamlak.length }} számla · {{ konyveletlenDb }} könyveletlen<ng-container *ngIf="nemKonyvelhetoDb"> · {{ nemKonyvelhetoDb }} nem könyvelhető</ng-container></span>
  </div>

  <div class="ures" *ngIf="betoltes && !szamlak.length"><ion-spinner name="dots"></ion-spinner></div>
  <div class="ures" *ngIf="!betoltes && !lathato.length">
    <ion-icon name="cloud-outline"></ion-icon>
    {{ szamlak.length ? 'Nincs a szűrésnek megfelelő számla.' : (feladatId ? 'A NAV-lekérés fut…' : 'Nincs tárolt számla ebben az irányban.') }}
  </div>

  <!-- A lista oldalra görgetés nélkül fér el: a kelt/teljesítés és a nettó/ÁFA/bruttó egy-egy
       cellában, a partner és a számlaszám tördelődik. -->
  <div class="tabla-wrap ov-lista" *ngIf="lathato.length">
    <table class="n-racs ov-racs">
      <thead><tr>
        <th class="ov-jelolo"></th><th>Számlaszám</th><th>Partner</th><th>Kelt / telj.</th>
        <th class="num">Bruttó <span class="ov-al">nettó + ÁFA</span></th><th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let s of lathato" [class.kijelolt]="kijelolt.has(s.szamlaszam)" [class.ov-konyvelt]="konyveltE(s)" [class.ov-nemk]="s.nem_konyvelheto">
          <td class="ov-jelolo"><input type="checkbox" [checked]="kijelolt.has(s.szamlaszam)" (change)="kijelolValt(s)" [disabled]="!elonezet && (konyveltE(s) || elozoEvi(s) || s.nem_konyvelheto)"></td>
          <td class="ov-szla"><b>{{ s.szamlaszam }}</b>
            <div class="ov-jelek">
              <span class="ov-jel ok" *ngIf="konyveltE(s) && !csatoltE(s)">könyvelt</span>
              <span class="ov-jel ok" *ngIf="csatoltE(s)" title="Az eredeti számlához kötve – a kettő együtt érvényes">csatolva</span>
              <span class="ov-jel" *ngIf="elonezet && s.mar_beemelve">már beemelve</span>
              <span class="ov-jel rossz" *ngIf="s.muvelet === 'STORNO'">storno</span>
              <span class="ov-jel nemk" *ngIf="s.nem_konyvelheto" [title]="'Nem könyvelhető' + (s.nem_konyvelheto_ok ? ': ' + s.nem_konyvelheto_ok : '') + (s.nem_konyvelheto_ki ? ' (' + s.nem_konyvelheto_ki + ')' : '')">
                nem könyvelhető{{ s.nem_konyvelheto_ok ? ' · ' + s.nem_konyvelheto_ok : '' }}</span>
              <span class="ov-jel figy" *ngIf="elozoEvi(s)" [title]="s.elozo_nyitott ? 'Előző évből nyitva maradt, átemelt tétel – a nyitó egyenlegben már benne van, újra nem könyvelhető' : 'Előző évi számla – az előző év könyveléséhez tartozik'">
                előző évi{{ s.elozo_nyitott ? ' · nyitott tétel (nyitóban)' : '' }}</span>
              <span class="ov-jel figy" *ngIf="s.eredeti_szamlaszam" (click)="eredeti(s)" title="Az eredeti számla képe">módosító → {{ s.eredeti_szamlaszam }}</span>
            </div>
          </td>
          <td class="ov-partner">{{ s.partner_nev }}
            <span class="ov-jel" *ngIf="s.partner_kepbol" title="A NAV nem adta át (magánszemély) – a számlaképből kiolvasva">a számlaképből</span>
            <span class="halvany" *ngIf="!s.partner_nev && s.irany === 'outbound'">{{ vevoFeladat ? 'vevő olvasása a számlaképből…' : (s.nav_pdf_id || s.dok_pdf_id ? 'magánszemély – nem olvasható ki' : 'magánszemély – előbb a számlaképet töltsd le') }}</span>
            <div class="halvany" *ngIf="s.partner_adoszam">{{ s.partner_adoszam }}</div></td>
          <td class="ov-datum">{{ s.kelt }}<div class="halvany" *ngIf="s.teljesites && s.teljesites !== s.kelt">telj. {{ s.teljesites }}</div></td>
          <td class="num ov-osszeg"><b>{{ szam(s.brutto) }}</b><span *ngIf="s.deviza && s.deviza !== 'HUF'"> {{ s.deviza }}</span>
            <div class="halvany">{{ szam(s.netto) }} + {{ szam(s.afa) }}</div>
            <div *ngIf="s.brutto_huf != null" class="halvany" [title]="'MNB ' + s.arfolyam + ' Ft/' + s.deviza + ' (' + s.arfolyam_datum + ')'">= {{ szam(s.brutto_huf) }} Ft</div>
          </td>
          <td><div class="ov-muv">
            <button type="button" class="kv-mini" title="Számlakép" (click)="kep.emit(s)"><ion-icon name="document-text-outline"></ion-icon></button>
            <button type="button" class="kv-mini" *ngIf="s.nav_pdf_id" title="NAV PDF" (click)="navPdf(s)"><ion-icon name="reader-outline"></ion-icon></button>
            <!-- Nincs tárolt kép: a NAV Számlázóból célzottan lehozzuk ehhez az egy számlához. -->
            <button type="button" class="kv-mini" *ngIf="!s.nav_pdf_id && !s.dok_pdf_id && s.irany === 'outbound'"
                    [disabled]="!!kepFeladat" title="Számlakép letöltése a NAV Számlázóból (háttérben)"
                    (click)="kepLetolt(s)"><ion-icon [name]="kepFeladat ? 'hourglass-outline' : 'cloud-download-outline'"></ion-icon></button>
            <button type="button" class="kv-mini" *ngIf="s.dok_pdf_id" title="Dokumentum (beérkezett PDF)" (click)="dokPdf(s)"><ion-icon name="attach-outline"></ion-icon></button>
            <button type="button" class="kv-mini" *ngIf="!konyveltE(s) && !elonezet && !s.nem_konyvelheto" title="Nem könyvelhető – kikerül a könyvelendők közül"
                    (click)="nemKonyvelheto(s, true)"><ion-icon name="ban-outline"></ion-icon></button>
            <button type="button" class="ov-gomb" *ngIf="s.nem_konyvelheto && !elonezet" title="Visszakerül a könyvelendők közé" (click)="nemKonyvelheto(s, false)">
              <ion-icon name="arrow-undo-outline"></ion-icon>Visszaállítás</button>
            <button type="button" class="ov-gomb fo" *ngIf="!konyveltE(s) && !elonezet && !elozoEvi(s) && !s.nem_konyvelheto && nullasModosito(s)" (click)="csatol.emit(s)"
                    [title]="'0 Ft-os módosító: nincs mit könyvelni – az eredetihez (' + s.eredeti_szamlaszam + ') kötjük, a kettő együtt érvényes'">
              <ion-icon name="link-outline"></ion-icon>Csatolás
            </button>
            <button type="button" class="ov-gomb fo" *ngIf="!konyveltE(s) && !elonezet && !elozoEvi(s) && !s.nem_konyvelheto && !nullasModosito(s)" (click)="konyvel.emit(s)" title="Könyvelés ebből a számlából">
              <ion-icon name="arrow-forward"></ion-icon>Könyvelés
            </button>
          </div></td>
        </tr>
      </tbody>
    </table>
  </div>
  </ng-container>

  <!-- Nyugta-összesítők (Számla és Kassza napi nyugta-adatszolgáltatása) → bevételként könyvelhető -->
  <ng-container *ngIf="nezet === 'nyugta'">
    <!-- Közvetlen NAV eNyugta-lekérés (a kliens NAV technikai felhasználójával) -->
    <div class="n-szuro-sor" style="margin-bottom:8px;align-items:flex-end;gap:10px">
      <b style="font-size:12.5px">NAV eNyugta – közvetlen lekérés:</b>
      <label style="font-size:12px">Dátumtól <input type="date" [(ngModel)]="enyugtaTol"></label>
      <label style="font-size:12px">– <input type="date" [(ngModel)]="enyugtaIg"></label>
      <button type="button" class="ov-gomb fo" [disabled]="enyugtaFut" (click)="enyugtaLeker()">
        <ion-spinner *ngIf="enyugtaFut" name="dots"></ion-spinner>
        <span *ngIf="!enyugtaFut"><ion-icon slot="start" name="cloud-download-outline"></ion-icon>Lekérés a NAV eNyugtából</span>
      </button>
      <span class="halvany" *ngIf="enyugtaUzenet" style="font-size:12px">{{ enyugtaUzenet }}</span>
    </div>
    <div class="tabla-wrap ov-lista" *ngIf="enyugtaNapok.length" style="margin-bottom:12px">
      <table class="n-racs ov-nyugta">
        <thead><tr><th class="ov-nyit-fej"></th><th>Nap</th><th>Sorszám</th><th class="num">Nyugta</th><th class="num">Módosító</th><th class="num">Összeg</th><th>Státusz</th><th>Szoftver</th></tr></thead>
        <tbody>
          <ng-container *ngFor="let n of enyugtaNapok">
            <tr class="ov-nyit-sor" [class.ov-nyitva]="n.nyitva" (click)="enyugtaNyit(n)" title="Kattints a tételes, ÁFA-kategóriánkénti bontásért">
              <td class="ov-nyit"><ion-icon [name]="n.nyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon></td>
              <td><b>{{ n.nap }}</b></td>
              <td class="halvany">{{ n.serialNumber || '—' }}</td>
              <td class="num">{{ n.dbNyugta }}</td>
              <td class="num">{{ n.dbModosito || '—' }}</td>
              <td class="num"><b>{{ szam(n.osszeg) }}</b> Ft</td>
              <td><span class="ov-jel" [class.ok]="n.statusz === 'PROCESSED' || n.statusz === 'DONE'">{{ n.statusz || '—' }}</span></td>
              <td class="halvany">{{ n.szoftver || '—' }}</td>
            </tr>
            <tr class="ov-detail-sor" *ngIf="n.nyitva">
              <td class="ov-nyit"></td>
              <td colspan="7">
                <div class="ov-detail">
                  <div class="ures" *ngIf="n.detailFut"><ion-spinner name="dots"></ion-spinner> Tételes bontás lekérése…</div>
                  <div class="ov-hiba" *ngIf="n.detailHiba">{{ n.detailHiba }}</div>
                  <ng-container *ngIf="n.detail">
                    <div class="ov-detail-fej">
                      <span>Deviza: <b>{{ n.detail.penznem || '—' }}</b></span>
                      <span *ngIf="n.detail.arfolyam != null">Árfolyam: <b>{{ n.detail.arfolyam }}</b></span>
                      <span *ngIf="n.detail.totalFt != null">Összeg (Ft): <b>{{ szam(n.detail.totalFt) }}</b></span>
                      <span class="spacer"></span>
                      <span class="halvany">Azonosító: {{ n.detail.id }}</span>
                    </div>
                    <table class="ov-kat">
                      <thead><tr><th>ÁFA-kategória</th><th class="num">Nyugta (bruttó)</th><th class="num">Módosító (bruttó)</th></tr></thead>
                      <tbody>
                        <tr *ngFor="let k of n.detail.kategoriak">
                          <td>{{ k.vat }}</td>
                          <td class="num">{{ szam(k.sale) }} {{ n.detail.penznem }}</td>
                          <td class="num">{{ k.mod ? (szam(k.mod) + ' ' + n.detail.penznem) : '—' }}</td>
                        </tr>
                        <tr *ngIf="!n.detail.kategoriak?.length"><td colspan="3" class="halvany">Nincs ÁFA-kategóriás bontás ebben az adatszolgáltatásban.</td></tr>
                      </tbody>
                    </table>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <p class="halvany" style="font-size:11.5px;margin:0 2px 10px">A NAV eNyugtából a cég saját nyugta-adatszolgáltatásai (napi összesítők). Könyvelésükhöz a lenti Kassza-összesítők, illetve a pénztárgép napi zárások valók – az eNyugta-lekérés az egyeztetéshez/ellenőrzéshez.</p>

    <div class="ov-tomeg" *ngIf="nyugtak.length">
      <button type="button" class="ov-gomb fo" [disabled]="nyugtaFut || !nyugtaKonyveletlenDb" (click)="nyugtakKonyvel()">
        <ion-icon name="journal-outline"></ion-icon>Nem könyveltek felvezetése ({{ nyugtaKonyveletlenDb }})
      </button>
      <span class="spacer"></span>
      <span class="halvany">{{ nyugtak.length }} nap · {{ nyugtaKonyveletlenDb }} könyveletlen</span>
    </div>
    <div class="ures" *ngIf="nyugtaBetoltes && !nyugtak.length"><ion-spinner name="dots"></ion-spinner></div>
    <div class="ures" *ngIf="!nyugtaBetoltes && !nyugtak.length">
      <ion-icon name="receipt-outline"></ion-icon>Nincs napi nyugta-összesítő (Számla és Kassza) ebben az évben.
    </div>
    <div class="tabla-wrap ov-lista" *ngIf="nyugtak.length">
      <table class="n-racs ov-nyugta">
        <thead><tr><th>Nap</th><th class="num">Összeg</th><th class="num">Nyugta</th><th>NAV eNyugta</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let n of nyugtak" [class.ov-konyvelt]="n.konyvelt">
            <td><b>{{ n.nap }}</b></td>
            <td class="num"><b>{{ szam(n.osszeg) }}</b> Ft</td>
            <td class="num">{{ n.db_nyugta }}<span *ngIf="n.db_modosito" class="halvany"> (+{{ n.db_modosito }} mód.)</span></td>
            <td><span class="ov-jel ok" *ngIf="n.bekuldve" title="Beküldve a NAV eNyugta nyugtaadat-szolgáltatásnak">beküldve</span>
              <span class="ov-jel" *ngIf="!n.bekuldve">{{ n.allapot || '—' }}</span></td>
            <td><div class="ov-muv">
              <span class="ov-jel ok" *ngIf="n.konyvelt">könyvelve<span *ngIf="n.konyvelt_mod"> · {{ n.konyvelt_mod }}</span></span>
              <button type="button" class="ov-gomb fo" *ngIf="!n.konyvelt" [disabled]="nyugtaFut" (click)="nyugtakKonyvel([n.id])" title="Napi nyugta-összesítő könyvelése bevételként">
                <ion-icon name="arrow-forward"></ion-icon>Könyvelés
              </button>
            </div></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
